import t from"tailwind-styled-components";import{twString as r}from"../utils.js";const e=t.h2`
  mt-1
  mb-2
  text-4xl
  tracking-tight
  text-current
  sm:text-3xl
  md:text-4xl
  lg:text-3xl
  xl:text-4xl
  ![line-height:1.2]

  ${({$rainbow:t})=>!0===t&&r`
    bg-clip-text
    bg-gradient-to-br
    from-brand-accent
    to-brand-primary
    [-webkit-text-fill-color:transparent;]
  `}
`;e.defaultProps={$rainbow:!1};export{e as default};
